import { User } from 'src/types/user';
import { get, post } from './Api';

async function login(username: string, password: string): Promise<any> {
  return post<any>('/user/login', { username, password, applicationName: 'SFA' });
}

async function logout(): Promise<null> {
  return get<null>('/user/logout');
}

async function me(): Promise<User> {
  return get<User>('/user/me');
}

export default {
  login,
  logout,
  me,
};
